import { ColDef } from 'ag-grid-community';
import { renderNA, importErrorFunction, generateImportColumn, importTextFormatEditor, formatEditor } from './../../../../../utils/commonFunctions';

/**
 * Column definitions for listing page
 * cellRenderer to show data as a string
 * valueGetter for getting data from export functionality of ag-grid
 * filterValueGetter for getting data from filter
 * tooltipValueGetter for getting data from tooltip
 * textFormatEditor for getting data from text editor
 */
// nameColumn,
const columnDefs: ColDef[] = [
    {
      ...generateImportColumn("", "experience"),
      pinned: "left",
      ...importErrorFunction(),
    },
    {
      ...generateImportColumn("", "zero_experience"),
      ...importErrorFunction(),
    },
    {
      ...generateImportColumn("", "level_1_supporting_activities"),

      ...importErrorFunction(),
    },
    {
      ...generateImportColumn("", "level_2_executing_activities"),
      ...importErrorFunction(),
    },
    {
      ...generateImportColumn("", "level_3_managing_activities"),
      ...importErrorFunction(),
    },
    {
      ...generateImportColumn("", "level_4_planning_strategic_work"),
      ...importErrorFunction(),
    },
    {
      ...generateImportColumn("", "level_5_leading_strategic_work"),
      ...importErrorFunction(),
    },
  ];
export default columnDefs;
